module.exports = __webpack_public_path__ + "1a9035d9df9337c0b055a40cdffb8895.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manual/Independent-Admin-System-Manual-v2.0.pdf
// module id = 9ehg
// module chunks = 1